import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.8",
      d: "m15.5 8.5-7 7m1-6.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m7 6a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M8.498 4.307l-.768-.179C5.566 3.625 3.625 5.566 4.128 7.73l.179.768a.5.5 0 0 1-.223.538l-.67.417c-1.885 1.174-1.885 3.919 0 5.093l.67.417a.5.5 0 0 1 .223.538l-.179.768c-.503 2.164 1.438 4.105 3.602 3.602l.768-.179a.5.5 0 0 1 .538.223l.417.67c1.174 1.885 3.919 1.885 5.093 0l.417-.67a.5.5 0 0 1 .538-.223l.768.179c2.164.503 4.105-1.438 3.602-3.602l-.179-.768a.5.5 0 0 1 .223-.538l.67-.417c1.885-1.174 1.885-3.92 0-5.093l-.67-.417a.5.5 0 0 1-.223-.538l.179-.768c.503-2.164-1.438-4.105-3.602-3.602l-.768.179a.5.5 0 0 1-.538-.223l-.417-.67c-1.174-1.885-3.92-1.885-5.093 0l-.417.67a.5.5 0 0 1-.538.223"
    }, null, -1)
  ])))
}
export default { render: render }